<template>
  <div class="media-list">
    <div class="breadcrumb-bar" v-show="doWhatTemp != 'view'">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/library/' }"
          >内容提供商</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{this.$route.query.cpid?"编辑书籍":"添加书籍"}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
      <addBookBasicInfo
        :basicInfo="basicInfo"
        :tagIds="tagIds"
        :doWhatTemp="doWhatTemp"
        @brandChose="brandChoseHandle"
      ></addBookBasicInfo>
      <div>
        <addBookDetail
          :detailInfo="detailInfo"
          :tagList="tagList"
          :tagForDetail="tagForDetail"
          :doWhatTemp="doWhatTemp"
          v-show="!liteMode"
        ></addBookDetail>
      </div>

      <el-button
        type="primary"
        @click="addContent('ebook')"
        style="float: right; margin: 20px 10px 20px 0"
        >{{ btnName }}电子书内容</el-button
      >
      <el-button
        type="primary"
        @click="addContent('audio')"
        style="float: right; margin: 20px 10px 20px 10px"
        >{{ btnName }}音视频内容</el-button
      >
      <el-button
        @click="doNextStep('formCustom')"
        style="float: right; margin: 20px 10px 20px 0"
        v-if="this.$route.query.do == 'edit'"
        >确定</el-button
      >

      <el-button
        @click="doNextStep1('formCustom1')"
        style="float: right; margin: 20px 10px 20px 0"
        v-if="this.$route.query.do == 'view'"
        >确定</el-button
      >
    </el-card>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
import addBookBasicInfo from "./components/addBook/addBookBasicInfo";
import addBookDetail from "./components/addBook/addBookDetail";
import addBookAginDetail from "./components/addBook/addBookAginDetail";

export default {
  name: "addbook",
  components: { addBookBasicInfo, addBookDetail, addBookAginDetail },
  data() {
    return {
      basicInfo: {
        bookName: "",
        imgUrl: "",
        brand: "",
        level: "",
        author: "",
      },
      contentInfo: {
        duration: null,
        audio: "",
        explainAudio: "",
        explainDuration: null,
        artist: "",
        video: "",
        poster: "",
        videoDuration: null,
        mode: 0,
      },
      STPInfo: {
        childBook: [],
        fatherBook: [],
        OID: "",
        oidRange: [[null, null]],
      },
      bnf: {
        url: "",
        size: null,
        md5: "",
      },
      detailInfo: {
        nickname: "",
        ISBN: "",
        desc: "",
        pageCnt: "",
        wordCnt: "",
        IDX_YL: "",
        IDX_AR: "",
        IDX_LX: "",
        IDX_PERC: "",
        IDX_CEFR: [],
        vocabulary: null,
        buyUrls: [
          {
            name: "",
            url: "",
          },
        ],
        bindAlbum: [],
      },
      doWhatTemp: "",
      tagList: [],
      tagIds: [],
      tagForDetail: {
        age: [],
        publisher: [],
        form: [],
        type: [],
        tongue: [],
        theme: [],
        award: [],
      },
      //packageId: null,
      //searchPackage: [],
      book: null,
      brandId: null,
      appid: "",
      pressName: "",
      btnName: "",
    };
  },
  created() {
    this.fetchTagList().then((res) => {
      if (this.$route.query.bookid != undefined) {
        if (this.$route.query.appid != undefined) {
          this.appid = this.$route.query.appid;
        } else {
          this.appid = this.$API.APPID;
        }
        this.fetchquery().then((res) => {
          if (res != null) {
            this.book = JSON.parse(res);
            this.basicInfo.bookName = this.book.name;
            this.basicInfo.imgUrl = this.book.content.image;
            this.basicInfo.brand = this.book.content.brand;
            this.basicInfo.level = this.book.content.level;
            this.detailInfo.desc = this.book.content.desc;
            this.basicInfo.author = this.book.author;
            this.detailInfo.nickname = this.book.nickname;
            this.detailInfo.ISBN = this.book.content.ISBN;
            this.detailInfo.pageCnt = this.book.content.pageCnt;
            this.detailInfo.wordCnt = this.book.content.wordCnt;
            this.detailInfo.IDX_YL = this.book.content.IDX_YL;
            this.detailInfo.IDX_AR = this.book.content.IDX_AR;
            this.detailInfo.IDX_LX = this.book.content.IDX_LX;
            this.detailInfo.IDX_PERC = this.book.content.IDX_PERC;
            this.detailInfo.vocabulary = this.book.content.vocabulary;
            this.contentInfo.artist = this.book.artist;
            this.STPInfo.OID = this.book.content.OID;

            if (this.book.content.video != undefined) {
              this.contentInfo.video = this.book.content.video;
            }
            if (this.book.content.videoDuration != undefined) {
              this.contentInfo.videoDuration = this.book.content.videoDuration;
            }
            if (this.book.content.audio != undefined) {
              this.contentInfo.audio = this.book.content.audio;
            }
            if (this.book.content.duration != undefined) {
              this.contentInfo.duration = this.book.content.duration;
            }
            if (this.book.content.explainAudio != undefined) {
              this.contentInfo.explainAudio = this.book.content.explainAudio;
            }
            if (this.book.content.explainDuration != undefined) {
              this.contentInfo.explainDuration =
                this.book.content.explainDuration;
            }
            if (this.book.content.mode != undefined) {
              this.contentInfo.mode = this.book.content.mode;
            } else {
              this.contentInfo.mode = 0;
            }
            if (this.book.content.poster != undefined) {
              this.contentInfo.poster = this.book.content.poster;
            }
            if (
              this.book.content.oidRange != undefined &&
              this.book.content.oidRange.length != 0
            ) {
              this.STPInfo.oidRange = this.book.content.oidRange;
            }
            if (this.book.content.bnf != undefined) {
              this.bnf = this.book.content.bnf;
            }
            if (this.book.content.buyUrls != undefined) {
              if (this.book.content.buyUrls.length > 0) {
                this.detailInfo.buyUrls = this.book.content.buyUrls;
              }
            }
            if (this.book.content.IDX_CEFR != undefined) {
              if (this.book.content.IDX_CEFR == "") {
                this.detailInfo.IDX_CEFR = [];
              } else {
                if (this.book.content.IDX_CEFR.indexOf(";") != -1) {
                  this.detailInfo.IDX_CEFR =
                    this.book.content.IDX_CEFR.split(";");
                } else {
                  this.detailInfo.IDX_CEFR = [this.book.content.IDX_CEFR];
                }
              }
            }
            this.tagIds = this.book.tagIds;
            this.setTagForDetail();
            this.fetchBindAlbum();
            //如果有srcid，可以找到父节点
            if (this.book.src_id != 0) {
              this.fetchFatherBookById(this.book.src_id);
            }
            //用自己的id，来尝试找到儿子节点
            this.fetchChildrenBookById(this.book.id);
          }
        });
      } else {
        this.appid = this.$API.APPID;
      }
    });

    this.doWhatTemp = this.$route.query.do;
    if (this.doWhatTemp == "view") {
      this.btnName = "查看";
    } else if (this.doWhatTemp == "edit") {
      this.btnName = "制作";
    }
  },
  computed: {
    liteMode: function () {
      //  return accountModeCheck(this.$store.state.accountTypeStore.type);
      return false;
    },
  },
  watch: {},
  methods: {
    fetchFatherBookById(id) {
      let params = {
        appId: this.appid,
        id: [id],
      };
      let cpidList = [];
      this.allAllCp(cpidList);
      params.dbId = cpidList;

      this.fetchBookId(params).then((res) => {
        if (res != null) {
          this.STPInfo.fatherBook = JSON.parse(res);
        }
      });
    },
    fetchChildrenBookById(id) {
      let params = {
        appId: this.appid,
        src_id: [id],
      };

      let cpidList = [];
      this.allAllCp(cpidList);
      params.dbId = cpidList;

      this.fetchBookId(params).then((res) => {
        if (res != null) {
          this.STPInfo.childBook = JSON.parse(res);
          id = [];
          for (let i in this.STPInfo.childBook) {
            this.STPInfo.childBook[i].isSync = false;
            id.push(this.STPInfo.childBook[i].id);
          }
          if (id.length > 0) {
            params.src_id = id;
            this.fetchBookId(params).then((res2) => {
              if (res2 != null) {
                let m2 = JSON.parse(res2);
                for (let i in m2) {
                  m2[i].isSync = false;
                  this.STPInfo.childBook.push(m2[i]);
                }
              }
            });
          }
        }
      });
    },
    fetchBookId(params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("/aries-api/resource/list", params)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              resolve(JSON.stringify(response.data.data.list));
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    allAllCp(cpid) {
      var cpList = JSON.parse(sessionStorage.getItem("cpList"));
      if (cpList != null) {
        if (0 != cpList.length) {
          for (let i = 0; i < cpList.length; ++i) {
            cpid.push(cpList[i].id);
          }
        } else {
          console.log("resultArr：" + result + " is null");
        }
      }
    },
    doNextStep1(name) {
      if (name == "formCustom1") {
        this.$router.push({
          name: "borrow",
        });
      }
    },
    doNextStep(name) {
      if (this.checkPackage()) {
        alert("请填入点读包的验证签名和大小");
        return;
      }
      if (this.doWhatTemp === "edit") {
        //this.$refs[name].validate((valid) => {
        //if (valid) {
        if (this.basicInfo.bookName == "") {
          alert("名字是必填项，请填写书籍名称 ");
          return;
        }
        if (this.$route.query.bookid === undefined) {
          let content = {
            image: this.basicInfo.imgUrl,
            desc: this.detailInfo.desc,
            OID: this.STPInfo.OID,
            level: this.basicInfo.level,
            brand: this.basicInfo.brand,
            video: this.contentInfo.video,
            videoDuration: this.contentInfo.videoDuration,
            poster: this.contentInfo.poster,
            audio: this.contentInfo.audio,
            duration: this.contentInfo.duration,
            mode: this.contentInfo.mode,
            explainAudio: this.contentInfo.explainAudio,
            explainDuration: this.contentInfo.explainDuration,
            buyUrls: this.checkBuyUrls(),
            oidRange: this.checkOIDRange(),
            ISBN: this.detailInfo.ISBN,
            pageCnt: Number(this.detailInfo.pageCnt),
            wordCnt: Number(this.detailInfo.wordCnt),
            IDX_YL: this.detailInfo.IDX_YL,
            IDX_AR: this.detailInfo.IDX_AR,
            IDX_LX: this.detailInfo.IDX_LX,
            IDX_PERC: this.detailInfo.IDX_PERC,
            IDX_CEFR: this.formatCEFR(),
            vocabulary: this.detailInfo.vocabulary,
          };
          let params = {
            appId: this.appid,
            id: 0, //新增的id设置为0
            name: this.basicInfo.bookName,
            content: content,
            dbId: Number(this.$route.query.cpid),
            type: 10,
            clevel: 2,
            artist: this.contentInfo.artist,
            author: this.basicInfo.author,
            nickname: this.detailInfo.nickname,
            categoryId: 11,
          };
          if (this.basicInfo.level != "") {
            params.keywords = this.basicInfo.level;
          }
          this.addBNF(params);
          this.setTagIds(params);
          if (this.pressName != "") {
            params.content.press = this.pressName;
          }
          this.sendAddRequest(params, name);
        } else {
          this.book.appId = this.appid;
          this.book.name = this.basicInfo.bookName;
          this.book.artist = this.contentInfo.artist;
          this.book.content.image = this.basicInfo.imgUrl;
          this.book.content.desc = this.detailInfo.desc;
          this.book.content.OID = this.STPInfo.OID;
          this.book.content.level = this.basicInfo.level;
          this.book.content.brand = this.basicInfo.brand;
          this.book.content.video = this.contentInfo.video;
          this.book.content.videoDuration = this.contentInfo.videoDuration;
          this.book.content.poster = this.contentInfo.poster;
          this.book.content.audio = this.contentInfo.audio;
          this.book.content.duration = this.contentInfo.duration;
          this.book.content.mode = this.contentInfo.mode;
          this.book.content.explainAudio = this.contentInfo.explainAudio;
          this.book.content.explainDuration = this.contentInfo.explainDuration;
          this.book.content.buyUrls = this.checkBuyUrls();
          this.book.content.oidRange = this.checkOIDRange();
          this.book.author = this.basicInfo.author;
          this.book.nickname = this.detailInfo.nickname;
          this.book.content.ISBN = this.detailInfo.ISBN;
          this.book.content.pageCnt = Number(this.detailInfo.pageCnt);
          this.book.content.wordCnt = Number(this.detailInfo.wordCnt);
          this.book.content.IDX_YL = this.detailInfo.IDX_YL;
          this.book.content.IDX_AR = this.detailInfo.IDX_AR;
          this.book.content.IDX_LX = this.detailInfo.IDX_LX;
          this.book.content.IDX_PERC = this.detailInfo.IDX_PERC;
          this.book.content.IDX_CEFR = this.formatCEFR();
          this.book.content.vocabulary = this.detailInfo.vocabulary;
          this.book.categoryId = 11;

          if (this.basicInfo.level != "") {
            this.book.keywords = this.basicInfo.level;
          }
          this.addBNF(this.book);
          this.setTagIds(this.book);
          if (this.pressName != "") {
            this.book.content.press = this.pressName;
          }
          this.sendAddRequest(this.book, name);
        }
        //}
        //});
      } else if (this.doWhatTemp === "view" || this.doWhatTemp === "quantu") {
        this.jumpToEditorPage(this.$route.query.bookid, this.$route.query.cpid);
      }
    },
    checkBuyUrls() {
      let validBuyUrl = false;
      for (let i = 0; i < this.detailInfo.buyUrls.length; ++i) {
        if (
          this.detailInfo.buyUrls[i].name != "" ||
          this.detailInfo.buyUrls[i].url != ""
        ) {
          validBuyUrl = true;
          break;
        }
      }
      if (validBuyUrl) {
        return this.detailInfo.buyUrls;
      } else {
        return [];
      }
    },
    formatCEFR() {
      if (this.detailInfo.IDX_CEFR.length == 0) {
        return "";
      } else if (this.detailInfo.IDX_CEFR.length == 1) {
        return this.detailInfo.IDX_CEFR[0];
      } else {
        let str = "";
        for (let i in this.detailInfo.IDX_CEFR) {
          str += this.detailInfo.IDX_CEFR[i];
          if (i != this.detailInfo.IDX_CEFR.length - 1) {
            str += ";";
          }
        }
        return str;
      }
    },
    checkOIDRange() {
      if (this.STPInfo.oidRange.length === 1) {
        if (
          (this.STPInfo.oidRange[0][0] === null ||
            this.STPInfo.oidRange[0][0] === "") &&
          (this.STPInfo.oidRange[0][1] === null ||
            this.STPInfo.oidRange[0][1] === "")
        ) {
          return [];
        } else {
          return this.STPInfo.oidRange;
        }
      } else {
        return this.STPInfo.oidRange;
      }
    },
    fetchquery() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.appid,
          id: Number(this.$route.query.bookid),
          dbId: Number(this.$route.query.cpid),
        };
        this.$axios
          .post("/aries-api/resource/get", params)
          .then((response) => {
            console.log(response);
            var m = response.data;
            if (m.result == 0) {
              resolve(JSON.stringify(m.data));
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    sendAddRequest(params, name) {
      this.checkOIDNoSpace(params);
      this.$axios
        .post("/aries-api/resource/save", params)
        .then((response) => {
          console.log(response);
          if (response.data.result == "0") {
            let id = response.data.data.id;
            let cpid = response.data.data.dbId;
            if (name == "formCustom") {
              this.jumpToEditorPage(id, cpid);
            } else {
              this.jumpToAddContent(id, name);
            }
          } else {
            alert(
              "post failed:" + response.data.result + ". " + response.data.msg
            );
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    checkOIDNoSpace(params) {
      if (params.content != undefined) {
        let content = params.content;
        if (content.pages != undefined) {
          let pages = content.pages;
          for (let i in pages) {
            if (pages[i].readPoints != undefined) {
              let point = pages[i].readPoints;
              for (let j in point) {
                if (point[j].OID != undefined) {
                  if (point[j].OID.indexOf(" ") != -1) {
                    console.log(point[j].OID);
                    params.content.pages[i].readPoints[j].OID =
                      point[j].OID.trim();
                  }
                }
              }
            }
          }
        }
      }
    },
    jumpToEditorPage(id, cpid) {
      this.$router.push({
        name: "library",
      });
    },
    addContent(content) {
      let bookId = null;
      if (this.$route.query.bookid != undefined) {
        bookId = this.$route.query.bookid;
        this.jumpToAddContent(bookId, content);
      } else {
        this.doNextStep(content);
      }
    },
    jumpToAddContent(bookId, content) {
      this.$router.push({
        name: "addcontent",
        query: {
          content: content,
          cpid: this.$route.query.cpid,
          bookid: bookId,
          do: this.doWhatTemp,
        },
      });
    },
    checkPackage() {
      if (this.bnf.url != "") {
        if (
          this.bnf.size == "" ||
          this.bnf.size == null ||
          this.bnf.md5 == ""
        ) {
          return true;
        }
      }
      return false;
    },
    addBNF(params) {
      if (this.bnf.url != "") {
        let temp = {
          bnf: this.bnf,
        };
        params.content = Object.assign({}, params.content, temp);
      } else {
        if (params.content.bnf != undefined) {
          delete params.content.bnf;
        }
      }
    },
    fetchTagList() {
      return new Promise((resolve, reject) => {
        let temp = {
          appId: this.$API.APPID,
          pid: 0,
          showAll: 1,
        };
        this.$axios
          .post("/aries-api/tag/list", temp)
          .then((response) => {
            console.log(response);
            if (response.data.result == 0) {
              let m = response.data.data;
              for (let i in m) {
                if (m[i].id == 74) {
                  this.tagList = m[i].children;
                  resolve(m);
                  break;
                }
              }
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    brandChoseHandle(name, id) {
      this.brandId = id;
      this.basicInfo.brand = name;
    },
    setTagIds(book) {
      book.tagIds = [];
      for (let i in this.tagForDetail.age) {
        book.tagIds.push(this.tagForDetail.age[i]);
      }
      for (let i in this.tagForDetail.publisher) {
        book.tagIds.push(this.tagForDetail.publisher[i]);
        this.queryBookPress(this.tagForDetail.publisher[i]);
      }
      for (let i in this.tagForDetail.form) {
        book.tagIds.push(this.tagForDetail.form[i]);
      }
      for (let i in this.tagForDetail.type) {
        book.tagIds.push(this.tagForDetail.type[i]);
      }
      for (let i in this.tagForDetail.tongue) {
        book.tagIds.push(this.tagForDetail.tongue[i]);
      }
      for (let i in this.tagForDetail.theme) {
        book.tagIds.push(this.tagForDetail.theme[i]);
      }
      for (let i in this.tagForDetail.award) {
        book.tagIds.push(this.tagForDetail.award[i]);
      }
      if (this.brandId != null) {
        book.tagIds.push(this.brandId);
      }
    },
    setTagForDetail() {
      for (let i in this.tagIds) {
        this.matchIdInTagList(this.tagIds[i]);
      }
    },
    matchIdInTagList(id) {
      for (let j in this.tagList) {
        let item = this.tagList[j].children;
        for (let k in item) {
          if (id == item[k].id) {
            switch (item[k].pid) {
              case 75: {
                this.tagForDetail.age.push(id);
                break;
              }
              case 81: {
                this.tagForDetail.publisher.push(id);
                break;
              }
              case 78: {
                this.tagForDetail.form.push(id);
                break;
              }
              case 79: {
                this.tagForDetail.type.push(id);
                break;
              }
              case 80: {
                this.tagForDetail.tongue.push(id);
                break;
              }
              case 77: {
                this.tagForDetail.theme.push(id);
                break;
              }
              case 203: {
                this.tagForDetail.award.push(id);
                break;
              }
              default:
                break;
            }
            return;
          }
        }
      }
    },
    fetchBindAlbum() {
      let temp = {
        appId: this.$API.APPID,
        dbId: this.book.dbId,
        page: 1,
        pageSize: 500,
        rid: this.book.id,
      };
      this.$axios
        .post("/aries-api/resource/listBindAlbums", temp)
        .then((response) => {
          console.log(response);
          if (response.data.result == 0) {
            this.detailInfo.bindAlbum = response.data.data.list;
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    queryBookPress(pressId) {
      let pressArr = [];
      for (let i in this.tagList) {
        if (this.tagList[i].id == 81) {
          pressArr = this.tagList[i].children;
          break;
        }
      }
      for (let i in pressArr) {
        if (pressId == pressArr[i].id) {
          this.pressName = pressArr[i].label;
          break;
        }
      }
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
</style>


// WEBPACK FOOTER //
// addBook.vue?67e101ea